const validateBreakChannelTable = (breakChannelTypes) => {
  if (!breakChannelTypes.length) return 'At least one break pattern detail is required';

  const requiredFields = ['slotPosition', 'selection'];

  const hasEmptyFields = breakChannelTypes.some((breakType) =>
    requiredFields.some(
      (field) =>
        breakType[field] === null || breakType[field] === undefined || breakType[field] === '',
    ),
  );

  if (hasEmptyFields) {
    return 'Rows cannot have empty segment or selection values.';
  }

  return null;
};

export const validateBreakPattern = (patternData) => {
  const { contentLevel, breakChannelTypes, default: defaultEnabled, versionName } = patternData;

  const versionNameError = versionName ? '' : 'Pattern name is required';

  // Validate content levels
  const contentLevelErrors = {
    eventType: contentLevel.eventType || defaultEnabled ? '' : 'Event type is required',
    eventName: contentLevel.eventName || defaultEnabled ? '' : 'Event name is required',
  };

  // Validate break channel type rows
  const breakChannelTableError = validateBreakChannelTable(breakChannelTypes);

  const hasErrors =
    versionNameError || breakChannelTableError || Object.values(contentLevelErrors).some(Boolean);

  return {
    hasErrors,
    versionName: versionNameError,
    breakChannelTableError,
    contentLevel: {
      eventType: contentLevelErrors.eventType,
      eventName: contentLevelErrors.eventName,
    },
  };
};

export const validateBreakChannelType = (breakChannelType) => {
  const errorMessages = {
    slotPosition: breakChannelType.slotPosition ? '' : 'Segment is required',
    selection: breakChannelType.selection ? '' : 'Selection is required',
  };

  const hasErrors = Object.values(errorMessages).some(Boolean);

  return { hasErrors, ...errorMessages };
};
